import { render, staticRenderFns } from "./Physicians.vue?vue&type=template&id=059bbbfd&scoped=true&"
import script from "./Physicians.vue?vue&type=script&lang=js&"
export * from "./Physicians.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059bbbfd",
  null
  
)

export default component.exports